import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Button } from '../../../../../../../components'

const OrderJobList = ({ onClick, disabled, isEditMode, isMultipleJobs }) => {
  return disabled ? (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      rootClose
      rootCloseEvent="mousedown"
      placement="top"
      overlay={
        <Popover id="SASC-A">
          <div className="popover__body">
            {isEditMode ? 'Click Save Changes above.' : 'Please make a selection in the output.'}
          </div>
        </Popover>
      }
    >
      <div>
        <Button className="button -xsmall" disabled style={{ pointerEvents: 'none' }}>
          {isMultipleJobs ? 'Order Job List' : 'Order'}
        </Button>
      </div>
    </OverlayTrigger>
  ) : (
    <Button className="button -xsmall" onClick={onClick}>
      {isMultipleJobs ? 'Order Job List' : 'Order'}
    </Button>
  )
}

OrderJobList.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isMultipleJobs: PropTypes.number.isRequired,
}

export default OrderJobList
